import { useEffect, useRef } from "react";

import { debounce } from "@shared/utils/debounce/debounce";

interface UseDebounceOptions {
  flushOnUnmount?: boolean;
}

const useDebounce = <T extends (...args: any[]) => any>(
  fn: T,
  delay: number,
  options: UseDebounceOptions = {}
) => {
  const { flushOnUnmount = false } = options;
  const ref = useRef(debounce(fn, delay));

  useEffect(() => {
    const debounced = ref.current;

    return () => {
      if (flushOnUnmount) {
        debounced.flush();
      } else {
        debounced.cancel();
      }
    };
  }, [flushOnUnmount]);

  return ref.current;
};

export { useDebounce };
